import { Component, OnInit } from '@angular/core';
import { Trip } from '../../../models/trip';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { NgxRolesService } from 'ngx-permissions';
import { BrowserStack } from 'protractor/built/driverProviders';
declare const google: any;
declare const $: any;
import { Select2OptionData } from 'ng2-select2';
import { PNotifyService } from '../../../services/pnotify.service';
import * as moment from 'moment';

@Component({
  selector: 'app-trip-add',
  templateUrl: './trip-add.component.html',
  styleUrls: ['./trip-add.component.css']
})
export class TripAddComponent implements OnInit {

  trip: Trip;
  dateTimeInterval: '';
  clients: any[];
  schools: any[];
  buses: any[];
  client: any;
  map: any;
  address: string;
  marker: any;
  schoolPosition = { lat: 33.97008408418035, lng: -6.849778033398479 };
  tripPosition = { lat: 33.906203, lng: -6.9299658 };
  geocoder: any;
  zoom: any;
  public schoolsData: Array<Select2OptionData>;
  public busesData: Array<Select2OptionData>;
  pnotify = undefined;
  isResponsible = false;
  dateTimeFilterWE = (d: moment.Moment): boolean => {
    const day = d.day();
    // Prevent Saturday and Sunday from being selected.
    return day !== 0 && day !== 6;
  }

  constructor(
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
    private roleService: NgxRolesService,
    pnotifyService: PNotifyService
  ) {
    this.trip = new Trip();
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.isResponsible = true;
      this.client = this.authService.getUser().School.Client;
    } else {
      this.client = this.authService.getUser();
    }
    this.initSchoolSelect();
    this.pnotify = pnotifyService.getPNotify();
  }

  ngOnInit() {
    this.map = new google.maps.Map(document.getElementById('trip-map'));
  }

  initMap() {
    this.map = new google.maps.Map(document.getElementById('trip-map'));

    this.marker = new google.maps.Marker({
      position: this.tripPosition,
      map: this.map,
      draggable: true,
      zIndex: 100,
    });
    const infowindow = new google.maps.InfoWindow({
      content: '<strong>Destination</strong>'
    });
    this.marker.addListener('click', () => {
      infowindow.open(this.map, this.marker);
    });
    const markerSchool = new google.maps.Marker({
      position: this.schoolPosition,
      map: this.map,
      zIndex: 99,
      icon: 'assets/images/markers/school.png'
    });
    this.mapAutoComplete(this.map);

    this.geocoder = new google.maps.Geocoder();
    this.getAdressName(this.marker);
    google.maps.event.addListener(this.marker, 'dragend', () => {
      this.getAdressName(this.marker);
    });

  }

  getAdressName(marker) {
    this.geocoder.geocode({
      'latLng': marker.getPosition()
    }, (results, status) => {
      if (status == google.maps.GeocoderStatus.OK) {

        if (results[0]) {
          const address = this.addressByFormat(results, 'postal_code');
          const locationName = address.formatted_address;

          this.address = locationName;
          this.trip.destLat = marker.getPosition().lat();
          this.trip.destLng = marker.getPosition().lng();
          this.tripPosition = { lat: this.trip.destLat, lng: this.trip.destLng };
          const markerBounds = new google.maps.LatLngBounds();
          markerBounds.extend(this.schoolPosition);
          markerBounds.extend({ lat: this.trip.destLat, lng: this.trip.destLng });

          this.map.fitBounds(markerBounds);

        }
      }
    });

  }

  addressByFormat(addresses, format) {
    let result = null;
    for (let i = addresses.length - 1; i >= 0; i--) {
      if (addresses[i].types.indexOf(format) >= 0) {
        result = addresses[i];
      }
    }
    return result || addresses[0];
  }

  mapAutoComplete(map) {
    const input = document.getElementById('address');
    const autocomplete = new google.maps.places.Autocomplete(input);
    autocomplete.bindTo('bounds', map);

    // Set the data fields to return when the user selects a place.
    autocomplete.setFields(
      ['address_components', 'geometry', 'icon', 'name']);

    autocomplete.addListener('place_changed', () => {

      this.marker.setVisible(false);
      const place = autocomplete.getPlace();
      if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        window.alert('No details available for input: "' + place.name + '"');
        return;
      }

      // If the place has a geometry, then present it on a map.

      this.marker.setPosition(place.geometry.location);
      this.marker.setVisible(true);


      this.getAdressName(this.marker);
    });
  }


  changePosition() {
    this.marker.setPosition({ lat: this.trip.destLat, lng: this.trip.destLng });
    this.getAdressName(this.marker);
  }

  initSchoolSelect() {
    this.trip.schoolId = null;
    const params = new HttpParams({
      fromObject: {
        clientId: this.client.id
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      this.schools = schools;
      const array1 = [{ id: '', text: 'Choisir une école' }];
      const array2 = this.schools.map((school, index) => {
        if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
          return {
            id: school.id,
            text: school.name,
            selected: (this.authService.getUser().School.id === school.id) ? true : false
          };
        } else {
          return { id: school.id, text: school.name };
        }
      });
      this.schoolsData = array1.concat(array2);
      if (this.schools.length > 0) {
        this.schoolPosition = { lat: Number(this.schools[0].lat), lng: Number(this.schools[0].lng) };
        this.tripPosition = { lat: Number(this.schools[0].lat), lng: Number(this.schools[0].lng) };
      }
    });
  }
  schoolChanged(e: any) {
    this.trip.schoolId = e.value;
    this.busesData = [{ id: '', text: 'Choisir un bus' }];
    this.initMap();
    this.initBusSelect();
  }

  initBusSelect() {
    this.trip.busId = null;
    const params = new HttpParams({
      fromObject: {
        clientId: this.client.id,
        schoolId: this.trip.schoolId + ''
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      this.buses = buses;
      const array1 = [{ id: '', text: 'Choisir un bus' }];
      const array2 = this.buses.map(function (bus, index) {
        return { id: bus.id, text: bus.name };
      });
      this.busesData = array1.concat(array2);
    });
  }

  busChanged(e: any) {
    this.trip.busId = e.value;
  }

  onChangeSchool() {
    for (let i = 0; i < this.schools.length; i++) {
      if (this.schools[i].id == this.trip.schoolId) {
        this.schoolPosition = { lat: Number(this.schools[i].lat), lng: Number(this.schools[i].lng) };
        break;
      }
    }
    this.initMap();
    this.initBusSelect();
  }

  onSubmit(): void {
    this.trip.departureDate = moment(this.dateTimeInterval[0]).format('YYYY-MM-DD HH:mm:ss');
    this.trip.returnDate = moment(this.dateTimeInterval[1]).format('YYYY-MM-DD HH:mm:ss');
    this.http.post(
      '/api/trip/0',
      { trip: this.trip }
    ).subscribe(
      (trip: Trip) => {
        this.trip = trip;
        this.router.navigate(['/trip/view', this.trip.id]);
      },
      (error) => {
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/trip/trip-add/trip-add.component.ts